import styled from 'styled-components';

export const BannerWrapper = styled.div`
  width: auto;
  max-width: 960px;
  height: 278px;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
`;

export const BannerDetailWrapper = styled.div`
  width: auto;
  height: 300px;
  position: relative;
  cursor: pointer;
  *,
  after,
  before {
    box-sizing: border-box;
    border-radius: 8px;
  }
`;

export const ImageWrapper = styled.div``;

export const PrevIcon = styled.button`
  cursor: pointer;
  background-color: transparent;
  border: none;
  position: absolute;
  z-index: 2;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  max-width: fit-content;
`;
export const NextIcon = styled.button`
  cursor: pointer;
  background-color: transparent;
  border: none;
  position: absolute;
  z-index: 2;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  max-width: fit-content;
`;

export const BannerIconWrapper = styled.div`
  max-width: fit-content;
  padding: 10px;
  opacity: 0.5;
  border-radius: 2px;
  background-color: ${({ theme }) => theme.palette.white};
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 100%;
`;
